import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Resp } from './resp.model';

@Injectable()
export class RegService {
      public data: any;


      constructor(private httpclient: HttpClient) { }


      // calls step1 service
      regStepOne(json: string) {
      const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
                return this.httpclient.post<Resp>('/reg/trust/StepOne', json, { headers }).map(data => data);
      }

      getNativeWindow() {
            return window;
      }
}
